import { createAction } from 'redux-actions';
import { FirstTimeFlag, FirstTimeFlagsType } from './constants';

export type DropFirstTimeFlagPayload = {
  flag: FirstTimeFlag;
  redirectTo?: string;
};

/** Overwrites the store state. Do not use outside of storybook */
export const setFirstTimeFlags = createAction(
  '@@firstTimeFlags/SET_FLAGS',
  (payload: FirstTimeFlagsType) => payload
);

/** Drop a particular FTUE flag */
export const dropFirstTimeFlag = createAction(
  '@@firstTimeFlags/DROP_FLAG',
  (payload: DropFirstTimeFlagPayload) => payload
);

/** Drop a particular FTUE flag, but with less annoying API (identical in
 * effect to dropFirstTimeFlag) */
export const dropFirstTimeFlagSimple = (
  flag: FirstTimeFlag,
  redirectTo?: string
) => dropFirstTimeFlag({ flag, redirectTo });

/** Unset a particular FTUE flag in the store only.
 * Does NOT persist on backend, do not use unless you know what you're doing. */
export const unsetFirstTimeFlag = createAction(
  '@@firstTimeFlags/UNSET_FLAG',
  (flag: FirstTimeFlag) => ({ flag })
);
